// roboto_regular for body
// Poppins_regular for heading
// roboto_bold for buttons

export enum FontFamily {
  POPPINS_LIGHT = "Poppins_light",
  POPPINS_REGULAR = "Poppins_regular",
  POPPINS_BOLD = "Poppins_bold",
  ROBOTO_REGULAR = "Roboto_regular",
  ROBOTO_BOLD = "Roboto_bold",
}
